import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import LoanDetails from './LoanDetails';
import BorrowerDetails from './BorrowerDetails';
import PersonalDetails from './PersonalDetails';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import Person from '@material-ui/icons/Person';
import Assignment from '@material-ui/icons/Assignment';
import Group from '@material-ui/icons/Group';

export default class OnlineFormDetails extends React.Component {
  state = {
    tabIndex: 0,
  };

  handleChange = (event, tabIndex) => {
    this.setState({ tabIndex });
  };

  numOfPersons = () => (this.props.application.form.numberOfPersons);

  renderPersonalDetails = () => {
    const numOfPersons = parseInt(this.numOfPersons(), 10);
    if (numOfPersons === 1 ) {
      return (
        <Grid container spacing={16}>
          <Grid item xs={3}>
          </Grid>
          <Grid item xs={6}>
            <PersonalDetails person={this.props.application.form.person1}/>
          </Grid>
          <Grid item xs={3}>
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid container spacing={16}>
        {
          _.range(numOfPersons).map((i) => {
            return (
              <Grid item xs={parseInt(12/this.numOfPersons(), 10)} key={`person${i+1}`}>
               <PersonalDetails person={this.props.application.form[`person${i+1}`]}/>
              </Grid>
            )
          })
        }
      </Grid>
    );
  }

  render() {
    const { tabIndex } = this.state;
    return (
      <div>
        <AppBar position="static" color="default">
          <Tabs
            centered
            value={this.state.tabIndex}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab icon={<Assignment />} label="Loan Details" />
            <Tab icon={<Person />} label="Borrower Details" />
            <Tab icon={<Group />} label="Director/Guarantor Details" />
          </Tabs>
        </AppBar>
        <br/>
        {
          tabIndex === 0 && (
            <div>
              <Grid container spacing={16}>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={6}>
                  <LoanDetails application={this.props.application} />
                </Grid>
                <Grid item xs={3}>
                </Grid>
              </Grid>
            </div>
          )
        }
        {
          tabIndex === 1 && (
            <div>
              <Grid container spacing={16}>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={6}>
                  <BorrowerDetails application={this.props.application} />
                </Grid>
                </Grid>
                <Grid item xs={3}>
                </Grid>
            </div>
          )
        }
        {
          tabIndex === 2 && (
            <div>
              { this.renderPersonalDetails() }
            </div>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Applications/OnlineFormDetails.js